import { render } from "./RenovarMatricula.vue?vue&type=template&id=c836dd88&scoped=true"
import script from "./RenovarMatricula.vue?vue&type=script&lang=js"
export * from "./RenovarMatricula.vue?vue&type=script&lang=js"

import "./RenovarMatricula.vue?vue&type=style&index=0&id=c836dd88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c836dd88"]])

export default __exports__